import {Box, Divider, Grid, Typography} from '@mui/material';
import {ItemDataResponse, ItemDataUpdateRequest} from 'models/board/itemData';
import React, {useMemo} from 'react';
import {Control, UseFormSetValue, UseFormWatch} from 'react-hook-form';
import {FieldsRenderer} from '../FieldsRenderer';
import {useItemDataHelper} from 'hooks';
import {format} from 'date-fns';
import {AppButton} from 'components/buttons';
import {orderBy} from 'lodash';

export interface BoardItemDetailSectionProps {
    item: ItemDataResponse;
    control: Control<any, any>;
    setValue: UseFormSetValue<ItemDataUpdateRequest>;
    watch: UseFormWatch<ItemDataUpdateRequest>;
    loading?: boolean;
}

export const BoardItemDetailSection: React.FC<BoardItemDetailSectionProps> = ({
    item,
    loading,
    control,
    setValue,
    watch,
}) => {
    const {getItemDataSummaryVariablesList} = useItemDataHelper();

    const itemSummaryVariables = useMemo(() => getItemDataSummaryVariablesList(item), []);

    return (
        <div>
            <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                <Box display={'flex'} px={1} width={'100%'} alignItems={'flex-end'} justifyContent={'space-between'}>
                    <Box>
                        <Typography variant="h5">Details</Typography>
                        {item.createdDate && (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    verticalAlign: 'middle',
                                }}
                            >
                                {`Created by ${item.createdByName} ${format(new Date(item.createdDate), "'on' MM/dd/yyyy 'at' hh:mm a")}`}
                            </Typography>
                        )}
                    </Box>
                    <Box>
                        <AppButton isLoading={loading} sx={{mr: 1}} type="submit">
                            Save
                        </AppButton>
                    </Box>
                </Box>
            </Box>
            <Divider
                sx={{
                    my: 1,
                    borderStyle: 'dotted',
                    borderColor: 'tertiary.main',
                    borderWidth: '1px',
                }}
            />

            <Grid container spacing={1}>
                {orderBy(item.data, ['order'], ['asc']).map((field, index) => (
                    <FieldsRenderer
                        baseFieldName={`data.${index}.value`}
                        itemSummaryVariables={itemSummaryVariables}
                        watch={watch}
                        key={field.uniqueId}
                        itemId={item.id}
                        boardId={item.itemStatus?.boardId}
                        control={control}
                        gridSize={field.columnSize ?? 6}
                        setValue={setValue}
                        field={field}
                        indexKey={index}
                    />
                ))}
            </Grid>
        </div>
    );
};

export default BoardItemDetailSection;
